import { useTranslations } from '@vocab/react';
import { Box, Button } from 'braid-design-system';

import translations from './.vocab';

const RefreshRecommendationsButton = ({ onReset }: { onReset: () => void }) => {
  const { t } = useTranslations(translations);

  return (
    <Box maxWidth="content">
      <Button onClick={onReset} variant="soft">
        {t('Try different answers')}
      </Button>
    </Box>
  );
};

export default RefreshRecommendationsButton;
